const items = [];

export default {
    when() {
        return document.querySelectorAll('.collapse-toggle').length > 0;
    },

    mounted() {
        document.querySelectorAll('.collapse-toggle').forEach((button) => {
            items.push(new Collapse(button, button.dataset));
        });

        document.addEventListener('collapseOpening', function(e) {
            const collapse = e.detail.target;
            const collapseContent = collapse.querySelector('.segments__bottom');
            const fullHeight = (collapse.dataset.maxHeight ?? collapseContent.scrollHeight) + 'px';

            collapseContent.style.height = '0px';

            window.requestAnimationFrame(() => {
                collapseContent.style.height = fullHeight;
            });

            if (!collapse.dataset.maxHeight) {
                collapseContent.addEventListener('transitionend', function() {
                    collapseContent.style.height = 'auto'; // Reset to auto after transition for responsive purposes
                }, { once: true });
            }
        });

        document.addEventListener('collapseClosing', function(e) {
            const collapseContent = e.detail.target.querySelector('.segments__bottom');
            collapseContent.style.height = collapseContent.scrollHeight + 'px';

            window.requestAnimationFrame(() => {
                collapseContent.style.height = '0px';
            });
        });
    },

    destroy() {
        items.forEach((item) => {
            item.unbind();
        });
    },
};

const instances = new Map();

export class Collapse {
    constructor(element, options = {}) {
        this.element = element;
        this.options = {
            container: '.collapse-container',
            target: null,
            ...options,
        };
        this.container = this.element.closest(this.options.container);
        this.collapse = document.getElementById(this.options.target);
        this.handleClick = this.handleClick.bind(this);

        if (this.collapse && this.collapse.classList.contains('collapse-is-open')) {
            this.open();
        }

        this.bind();
        instances.set(this.element, this);
    }

    bind() {
        if (!this.element.classList.contains('collapse-ready')) {
            this.element.addEventListener('click', this.handleClick);
            this.element.classList.add('collapse-ready');
        }
    }

    close() {
        if (this.collapse) {
            const event = new CustomEvent('collapseClosing', { detail: { instance: this, target: this.collapse } });
            document.dispatchEvent(event);
            this.collapse.classList.remove('collapse-is-open');
        }
    }

    static getInstance(element) {
        return instances.get(element);
    }

    handleClick(e) {
        e.preventDefault();
        this.toggle();
    }

    open() {
        // if (this.container) {
        //     this.container.querySelectorAll('.collapse-toggle').forEach((button) => {
        //         const instance = this.constructor.getInstance(button);
        //         if (instance.collapse.classList.contains('collapse-is-open')) {
        //             instance.close();
        //         }
        //     });
        // }

        if (this.collapse) {
            const event = new CustomEvent('collapseOpening', { detail: { instance: this, target: this.collapse } });
            document.dispatchEvent(event);
            this.collapse.classList.add('collapse-is-open');
        }
    }

    toggle() {
        if (this.collapse && this.collapse.classList.contains('collapse-is-open')) {
            this.close();
        } else {
            this.open();
        }
    }

    unbind() {
        if (this.element.classList.contains('collapse-ready')) {
            this.element.removeEventListener('click', this.handleClick);
            this.element.classList.remove('collapse-ready');
        }
    }
}
